import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

// Função para criar anuncio da propriedade vinculada a cotaUsuario

export const anunciopPropriedadeService = async (cotasUsuariosId: number) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/anuncio-propriedade`;
    const values = {
      cotasUsuariosId: cotasUsuariosId,
      active: 0,
    };

    try {
      const response = await axios.post(URL, values, {
        headers: { Authorization: Token.AuthStr },
      });

      return response && response.data ? true : false;
    } catch (error) {
      console.log(error);
    }
  }
};

export {};
